var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSsn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    role: "img",
    "aria-label": "SSN status",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 104,
    height: 92,
    rx: 14,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 92,
    height: 80,
    rx: 10,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 34,
    width: 44,
    height: 10,
    rx: 4,
    fill: "#FFFFFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 76,
    width: 18,
    height: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 76,
    width: 12,
    height: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 76,
    width: 24,
    height: 13,
    rx: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 82.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 82.5,
    r: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsn);
export default __webpack_public_path__ + "static/media/ssn.8a5d7afde8293136b0195952637a22c9.svg";
export { ForwardRef as ReactComponent };